import httpClient from "@/httpClient"

const getCompanyPublic = (id) => httpClient.get(`/companies/${id}/public-data`)
const getUserCompanies = (account, config = {}) => httpClient.get(`/accounts/${account}/companies?config=1`, config)

export default {
  getCompanyPublic,
  getUserCompanies,
}
